'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  color: ', ';\n\n  div div label {\n    font-weight: 400;\n  }\n\n  span {\n    margin: 0;\n    font-weight: 400;\n  }\n  .DateRangePicker {\n    display: flex;\n\n    div .DateRangePickerInput{\n      border: 1px solid ', ';\n      border-radius: 5px;\n\n      .DateInput{\n        background: transparent;\n      }\n\n      .DateRangePickerInput__arrow{\n        svg{\n          fill: ', ';\n        }\n      }\n    }\n\n    div .DateInput--with-caret .DateInput__display-text{\n      background: ', ' ;\n      border-color: ', ' ;\n      border-radius: 5px;\n      color: ', ';\n    }\n  }\n\n  .DateInput__display-text--focused {\n    background: ', ' ;\n    border-color: ', ' ;\n    border-radius: 5px;\n    color: ', ';\n  }\n\n  .CalendarDay--selected-span, .CalendarDay--hovered-span, .CalendarDay--after-hovered-start{\n    background: ', ';\n    border: 1px double  ', ' ;\n    color: ', ';\n\n    &:hover{\n      background: ', ';\n    }\n  }\n\n  .CalendarDay--selected-start, .CalendarDay--selected-end, .CalendarDay--selected{\n    background: ', ';\n    border: 1px double  ', ';\n    color: ', ';\n  }\n\n  .DayPickerKeyboardShortcuts__show--bottom-right {\n    border-right: 33px solid ', ';\n  }\n\n  .SingleDatePicker {\n    div .SingleDatePickerInput{\n      border: 1px solid ', ';\n      border-radius: 5px;\n\n      .DateInput{\n        background: transparent;\n      }\n    }\n    display: flex;\n    .SingleDatePicker__picker {\n      ', '\n    }\n    .DateInput--with-caret::before, .DateInput--with-caret::after {\n      ', ';\n    }\n  }\n'], ['\n  width: 100%;\n  color: ', ';\n\n  div div label {\n    font-weight: 400;\n  }\n\n  span {\n    margin: 0;\n    font-weight: 400;\n  }\n  .DateRangePicker {\n    display: flex;\n\n    div .DateRangePickerInput{\n      border: 1px solid ', ';\n      border-radius: 5px;\n\n      .DateInput{\n        background: transparent;\n      }\n\n      .DateRangePickerInput__arrow{\n        svg{\n          fill: ', ';\n        }\n      }\n    }\n\n    div .DateInput--with-caret .DateInput__display-text{\n      background: ', ' ;\n      border-color: ', ' ;\n      border-radius: 5px;\n      color: ', ';\n    }\n  }\n\n  .DateInput__display-text--focused {\n    background: ', ' ;\n    border-color: ', ' ;\n    border-radius: 5px;\n    color: ', ';\n  }\n\n  .CalendarDay--selected-span, .CalendarDay--hovered-span, .CalendarDay--after-hovered-start{\n    background: ', ';\n    border: 1px double  ', ' ;\n    color: ', ';\n\n    &:hover{\n      background: ', ';\n    }\n  }\n\n  .CalendarDay--selected-start, .CalendarDay--selected-end, .CalendarDay--selected{\n    background: ', ';\n    border: 1px double  ', ';\n    color: ', ';\n  }\n\n  .DayPickerKeyboardShortcuts__show--bottom-right {\n    border-right: 33px solid ', ';\n  }\n\n  .SingleDatePicker {\n    div .SingleDatePickerInput{\n      border: 1px solid ', ';\n      border-radius: 5px;\n\n      .DateInput{\n        background: transparent;\n      }\n    }\n    display: flex;\n    .SingleDatePicker__picker {\n      ', '\n    }\n    .DateInput--with-caret::before, .DateInput--with-caret::after {\n      ', ';\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  font-size: 12px;\n  margin: 0 0 10px 0;\n  text-align: left;\n'], ['\n  font-size: 12px;\n  margin: 0 0 10px 0;\n  text-align: left;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCookie = require('react-cookie');

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../color');

var _color2 = _interopRequireDefault(_color);

var _reactDates = require('react-dates');

var _MozartRadio = require('../MozartInputBox/MozartRadio');

var _MozartRadio2 = _interopRequireDefault(_MozartRadio);

var _MozartModal = require('../MozartDialog/MozartModal/MozartModal');

var _MozartModal2 = _interopRequireDefault(_MozartModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DateRangeContainer = _styledComponents2.default.div(_templateObject, _color2.default.grey_main, _color2.default.blue_accent, _color2.default.blue_accent, _color2.default.blue_main, _color2.default.blue_main, _color2.default.white, _color2.default.blue_main, _color2.default.blue_main, _color2.default.white, _color2.default.purple_accent, _color2.default.grey_accent_1, _color2.default.grey_main, _color2.default.grey_accent_1, _color2.default.blue_main, _color2.default.blue_main, _color2.default.white, _color2.default.blue_main, _color2.default.blue_accent, function (props) {
  return props.closeSinglePicker ? 'display: none;' : '';
}, function (props) {
  return props.closeSinglePicker ? 'border: none;' : '';
});

var DateRangeNote = _styledComponents2.default.p(_templateObject2);

var MozartDatePicker = function (_Component) {
  _inherits(MozartDatePicker, _Component);

  /** Requirement for using MozartDatePicker:
   * 1. need to install react-dates@12.7.0
   * 2. import 'react-dates/lib/css/_datepicker.css' in css loader
   * */

  function MozartDatePicker(props) {
    _classCallCheck(this, MozartDatePicker);

    var _this = _possibleConstructorReturn(this, (MozartDatePicker.__proto__ || Object.getPrototypeOf(MozartDatePicker)).call(this, props));

    var startDate = (0, _moment2.default)().subtract(29, 'days');
    var endDate = (0, _moment2.default)();
    var specialcaseNum = null;
    var singleDate = (0, _moment2.default)();
    var focusedInput = null;
    if (props.autoFocus) {
      focusedInput = 'START_DATE';
    } else if (props.autoFocusEndDate) {
      focusedInput = 'END_DATE';
    }

    startDate = _reactCookie2.default.load('start_date' + (props.id ? props.id : '')) ? (0, _moment2.default)(new Date(_reactCookie2.default.load('start_date' + (props.id ? props.id : '')).replace(/"/g, ''))) : (0, _moment2.default)().subtract(props.sevenDaysRestrict ? 7 : 29, 'days');
    endDate = _reactCookie2.default.load('end_date' + (props.id ? props.id : '')) ? (0, _moment2.default)(new Date(_reactCookie2.default.load('end_date' + (props.id ? props.id : '')).replace(/"/g, ''))) : (0, _moment2.default)();
    specialcaseNum = _reactCookie2.default.load('specialcase' + (props.id ? props.id : '')) ? parseInt(_reactCookie2.default.load('specialcase' + (props.id ? props.id : '')), 10) : null;

    if (props.sevenDaysRestrict) {
      if (endDate.diff(startDate, 'days') > 7) {
        var newStartDate = endDate.clone();
        newStartDate.subtract(7, 'days');
        startDate = newStartDate;
        specialcaseNum = null;
      }
    }
    var today = new Date();
    var todayUTC = (0, _moment2.default)(today.getTime()).utcOffset('+00:00');
    if (parseInt(specialcaseNum, 10) === 1) {
      var startEnd1 = _this.convertToTimeone(todayUTC, today, _this.props.timezone, 1);
      startDate = startEnd1.start;
      endDate = startEnd1.end;
    }
    if (parseInt(specialcaseNum, 10) === 7) {
      var startEnd7 = _this.convertToTimeone(todayUTC, today, _this.props.timezone, 1);
      startDate = startEnd7.start;
      endDate = startEnd7.end;
    }
    if (parseInt(specialcaseNum, 10) === 30) {
      var startEnd30 = _this.convertToTimeone(todayUTC, today, _this.props.timezone, 29);
      startDate = startEnd30.start;
      endDate = startEnd30.end;
    }
    if (parseInt(specialcaseNum, 10) === 90) {
      var startEnd90 = _this.convertToTimeone(todayUTC, today, _this.props.timezone, 89);
      startDate = startEnd90.start;
      endDate = startEnd90.end;
    }
    if (parseInt(specialcaseNum, 10) === 365) {
      var startEnd365 = _this.convertToTimeone(todayUTC, today, _this.props.timezone, 364);
      startDate = startEnd365.start;
      endDate = startEnd365.end;
    }

    var expireDate = _this.getExpireDate();

    _reactCookie2.default.save('start_date' + (props.id ? props.id : ''), startDate, { path: '/', expires: expireDate });
    _reactCookie2.default.save('end_date' + (props.id ? props.id : ''), endDate, { path: '/', expires: expireDate });
    _reactCookie2.default.save('specialcase' + (props.id ? props.id : ''), specialcaseNum, { path: '/', expires: expireDate });

    var prevFilterDataStart = props.prevFilterDataStart,
        prevFilterDataEnd = props.prevFilterDataEnd,
        singleDateDisplay = props.singleDateDisplay;

    _this.state = {
      focusedInput: focusedInput,
      startDate: prevFilterDataStart ? prevFilterDataStart : startDate,
      endDate: prevFilterDataEnd ? prevFilterDataEnd : endDate,
      startDateDisplay: prevFilterDataStart ? prevFilterDataStart : startDate,
      endDateDisplay: prevFilterDataEnd ? prevFilterDataEnd : endDate,
      prevFilterDataStart: prevFilterDataStart ? prevFilterDataStart : startDate,
      prevFilterDataEnd: prevFilterDataEnd ? prevFilterDataEnd : endDate,
      specialcase: specialcaseNum,
      prevSpecialcase: specialcaseNum ? specialcaseNum : 30,
      singleDate: singleDate,
      singleDateDisplay: singleDateDisplay,
      focused: false,
      closeSinglePicker: true,
      showRestrictMsg: false,
      expireDate: expireDate
    };
    return _this;
  }

  _createClass(MozartDatePicker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _state = this.state,
          startDate = _state.startDate,
          endDate = _state.endDate;

      var specialcase = '';
      if (this.props.specialcase !== undefined) {
        specialcase = this.props.specialcase;
      } else {
        specialcase = (0, _moment2.default)(endDate).diff(startDate, 'days') + 1;
        specialcase = specialcase === 1 && (0, _moment2.default)().diff(endDate, 'days') !== 0 ? 'radiocustom' : specialcase;
      }
      if (specialcase === 1) {
        if (document.getElementById('radiotoday') !== null) {
          document.getElementById('radiotoday').checked = true;
        }
      } else {
        if (specialcase !== 1 && specialcase !== 7 && specialcase !== 30 && specialcase !== 90 && specialcase !== 365) {
          if (document.getElementById('radiotoday') !== null) {
            document.getElementById('radiocustomdays').checked = true;
          }
        } else {
          if (document.getElementById('radiotoday') !== null && document.getElementById('radio' + specialcase + 'days') !== null) {
            document.getElementById('radio' + specialcase + 'days').checked = true;
          }
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var type = nextProps.type;
      var id = this.props.id;
      var _state2 = this.state,
          startDate = _state2.startDate,
          endDate = _state2.endDate,
          prevFilterDataStart = _state2.prevFilterDataStart,
          prevFilterDataEnd = _state2.prevFilterDataEnd,
          specialcase = _state2.specialcase,
          prevSpecialcase = _state2.prevSpecialcase;

      if (type) {
        if (type === 'cancel') {
          this.setState({
            startDate: prevFilterDataStart,
            endDate: prevFilterDataEnd,
            specialcase: !isNaN(prevSpecialcase) ? prevSpecialcase : specialcase
          }, function () {
            _this2.autoSelectRadio(_this2.state.specialcase);
          });
        } else if (type === 'submit') {
          this.setState({
            prevFilterDataStart: startDate,
            prevFilterDataEnd: endDate,
            prevSpecialcase: specialcase
          }, function () {
            _reactCookie2.default.save('start_date' + (id ? id : ''), startDate, { path: '/', expires: _this2.state.expireDate });
            _reactCookie2.default.save('end_date' + (id ? id : ''), endDate, { path: '/', expires: _this2.state.expireDate });
            _reactCookie2.default.save('specialcase' + (id ? id : ''), specialcase, { path: '/', expires: _this2.state.expireDate });
            _this2.autoSelectRadio(specialcase);
          });
        }
      } else {
        // reload data when refresh page
        this.setState({
          startDateDisplay: (0, _moment2.default)(new Date(_reactCookie2.default.load('start_date' + (id ? id : '')).replace(/"/g, ''))),
          endDateDisplay: (0, _moment2.default)(new Date(_reactCookie2.default.load('end_date' + (id ? id : '')).replace(/"/g, '')))
        });
      }
    }
  }, {
    key: 'getExpireDate',
    value: function getExpireDate() {
      var cookieLifeTime = this.props.cookieLifeTime;

      var today = new Date();
      var todayUTCEnd = (0, _moment2.default)(today.getTime()).utcOffset('+00:00');
      return todayUTCEnd.add(cookieLifeTime, 'days').toDate();
    }
  }, {
    key: 'autoSelectRadio',
    value: function autoSelectRadio(currCase) {
      if (currCase === 1) {
        if (document.getElementById('radiotoday') !== null) {
          document.getElementById('radiotoday').checked = true;
        }
      } else {
        if (currCase !== 1 && currCase !== 7 && currCase !== 30 && currCase !== 90 && currCase !== 365) {
          if (document.getElementById('radiotoday') !== null) {
            document.getElementById('radiocustomdays').checked = true;
          }
        } else {
          if (document.getElementById('radiotoday') !== null) {
            document.getElementById('radio' + currCase + 'days').checked = true;
          }
        }
      }
    }
  }, {
    key: 'convertToTimeone',
    value: function convertToTimeone(todayUTC, today, timezone, dayOffset) {
      var start = (0, _moment2.default)();
      var end = (0, _moment2.default)();
      if (timezone === 'UTC') {
        var todayUTCEnd = (0, _moment2.default)(today.getTime()).utcOffset('+00:00');
        if (dayOffset > 1) {
          start = todayUTCEnd.subtract(dayOffset, 'days');
        } else {
          start = todayUTCEnd;
        }
        end = todayUTC;
      } else {
        start = (0, _moment2.default)();
        end = (0, _moment2.default)();
      }
      return { start: start, end: end };
    }
  }, {
    key: 'getData',
    value: function getData(value) {
      var totalDays = new Date().getFullYear() % 4 === 0 ? 366 : 365;
      var start = (0, _moment2.default)();
      var end = (0, _moment2.default)();
      var specialcase = null;
      var today = new Date();
      var todayUTC = (0, _moment2.default)(today.getTime()).utcOffset('+00:00');
      switch (value) {
        case '1':
          var startEnd1 = this.convertToTimeone(todayUTC, today, this.props.timezone, 1);
          start = startEnd1.start;
          end = startEnd1.end;
          specialcase = 1;
          break;
        case '7':
          var startEnd7 = this.convertToTimeone(todayUTC, today, this.props.timezone, 6);
          start = startEnd7.start;
          end = startEnd7.end;
          specialcase = 7;
          break;
        case '30':
          var startEnd30 = this.convertToTimeone(todayUTC, today, this.props.timezone, 29);
          start = startEnd30.start;
          end = startEnd30.end;
          specialcase = 30;
          break;
        case '90':
          var startEnd90 = this.convertToTimeone(todayUTC, today, this.props.timezone, 89);
          start = startEnd90.start;
          end = startEnd90.end;
          specialcase = 90;
          break;
        case '365':
          var startEnd365 = this.convertToTimeone(todayUTC, today, this.props.timezone, totalDays - 1);
          start = startEnd365.start;
          end = startEnd365.end;
          specialcase = 365;
          break;
        case 'customdays':
          start = this.state.start_date;
          end = this.state.end_date;
          specialcase = 'custom';
          break;
        default:
          start = (0, _moment2.default)();
          end = (0, _moment2.default)();
          break;
      }
      return {
        start: start,
        end: end,
        specialcase: specialcase
      };
    }
  }, {
    key: 'handleRadioBoxClick',
    value: function handleRadioBoxClick(event) {
      var _this3 = this;

      var _props = this.props,
          saveCookieWithoutButton = _props.saveCookieWithoutButton,
          id = _props.id;

      var selected = event.value;
      var data = this.getData(selected);
      var start = data.start;
      var end = data.end;
      var specialcase = data.specialcase;
      this.setState({
        startDate: start,
        endDate: end,
        specialcase: specialcase,
        startDateDisplay: start,
        endDateDisplay: end
      }, function () {
        _this3.onDatesChange({ startDate: start, endDate: end });
        _this3.props.handleChange('start_date', start, selected);
        _this3.props.handleChange('end_date', end, selected);
        _this3.props.handleChange('specialcase', specialcase, selected);
      });
      if (saveCookieWithoutButton) {
        _reactCookie2.default.save('start_date' + (id ? id : ''), start, { path: '/', expires: this.state.expireDate });
        _reactCookie2.default.save('end_date' + (id ? id : ''), end, { path: '/', expires: this.state.expireDate });
        _reactCookie2.default.save('specialcase' + (id ? id : ''), specialcase, { path: '/', expires: this.state.expireDate });
      }
    }
  }, {
    key: 'onDatesChange',
    value: function onDatesChange(startEndDates) {
      var startDate = startEndDates.startDate,
          endDate = startEndDates.endDate;

      this.setState({
        startDateDisplay: startDate,
        endDateDisplay: endDate
      });
    }
  }, {
    key: 'onClose',
    value: function onClose(arg) {
      var _this4 = this;

      var _state3 = this.state,
          startDate = _state3.startDate,
          endDate = _state3.endDate,
          specialcase = _state3.specialcase;
      var _props2 = this.props,
          saveCookieWithoutButton = _props2.saveCookieWithoutButton,
          id = _props2.id,
          sevenDaysRestrict = _props2.sevenDaysRestrict;

      if (startDate && endDate) {
        if (sevenDaysRestrict && arg.endDate.diff(arg.startDate, 'days') > 7) {
          var newEndDate = arg.startDate.clone();
          newEndDate.add(7, 'days');
          this.setState({ startDate: arg.startDate, endDate: newEndDate, showRestrictMsg: true, endDateDisplay: newEndDate }, function () {
            _this4.props.handleChange('start_date', arg.startDate);
            _this4.props.handleChange('end_date', newEndDate);
            _this4.props.handleChange('specialcase', specialcase);
          });
        } else {
          this.setState({ startDate: arg.startDate, endDate: arg.endDate }, function () {
            _this4.props.handleChange('start_date', arg.startDate);
            _this4.props.handleChange('end_date', arg.endDate);
            _this4.props.handleChange('specialcase', specialcase);
          });
          if (saveCookieWithoutButton) {
            _reactCookie2.default.save('start_date' + (id ? id : ''), arg.startDate, { path: '/', expires: this.state.expireDate });
            _reactCookie2.default.save('end_date' + (id ? id : ''), arg.startDate, { path: '/', expires: this.state.expireDate });
          }
        }
      } else {
        this.setState({
          startDateDisplay: this.state.startDate,
          endDateDisplay: this.state.endDate
        });
      }
    }
  }, {
    key: 'onFocusChange',
    value: function onFocusChange(focusedInput) {
      var _this5 = this;

      var singleDatePicker = this.props.singleDatePicker;

      if (singleDatePicker) {
        this.setState({
          closeSinglePicker: false,
          focused: focusedInput
        });
      } else {
        this.setState({ focusedInput: focusedInput }, function () {
          if (document.getElementById('radiotoday') !== null) {
            document.getElementById('radiocustomdays').checked = true;
            _this5.setState({ specialcase: null });
          }
        });
      }
    }
  }, {
    key: 'onDateChangeSingle',
    value: function onDateChangeSingle(date) {
      this.setState({
        closeSinglePicker: false,
        singleDateDisplay: date
      });
    }
  }, {
    key: 'onCloseSingle',
    value: function onCloseSingle() {
      var _this6 = this;

      var _state4 = this.state,
          closeSinglePicker = _state4.closeSinglePicker,
          singleDateDisplay = _state4.singleDateDisplay;

      if (!closeSinglePicker) {
        this.setState({ closeSinglePicker: true });
      }
      if (singleDateDisplay) {
        this.setState({ singleDate: singleDateDisplay }, function () {
          _this6.props.handleChange('singleDate', _this6.state.singleDate);
        });
      }
    }
  }, {
    key: 'handleHideCases',
    value: function handleHideCases(content, hidecases) {
      return content.filter(function (elem) {
        return !hidecases.includes(elem.key);
      });
    }
  }, {
    key: 'showSevenDaysRestrictMsg',
    value: function showSevenDaysRestrictMsg() {
      this.setState({ showRestrictMsg: !this.state.showRestrictMsg });
    }
  }, {
    key: 'getDateFormat',
    value: function getDateFormat(time) {
      var date = new Date(time);
      var dd = date.getDate();
      var mm = date.getMonth() + 1;
      var yyyy = date.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      var formatDate = mm + '/' + dd + '/' + yyyy;
      return formatDate;
    }
  }, {
    key: 'getSevenDaysRestrictMsg',
    value: function getSevenDaysRestrictMsg() {
      var _this7 = this;

      var _state5 = this.state,
          startDate = _state5.startDate,
          endDate = _state5.endDate;

      return _react2.default.createElement(
        _MozartModal2.default,
        {
          testId: 'filter_show_restrict_msg',
          onClose: function onClose() {
            _this7.showSevenDaysRestrictMsg();
          },
          title: 'Date Range Restricted Message',
          show: this.state.showRestrictMsg,
          submitLabel: 'Close',
          handleSubmit: function handleSubmit() {
            _this7.onDatesChange({ startDate: startDate, endDate: endDate });_this7.showSevenDaysRestrictMsg();
          } },
        _react2.default.createElement(
          'h4',
          null,
          'Date Range Restricted to 7 Days'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Restricted start date and end date:',
          _react2.default.createElement('br', null),
          'Start Date: ' + this.getDateFormat(startDate),
          _react2.default.createElement('br', null),
          'End Date: ' + this.getDateFormat(endDate)
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          id = _props3.id,
          noprefix = _props3.noprefix,
          horizontal = _props3.horizontal,
          testId = _props3.testId,
          themeId = _props3.themeId,
          singleDatePicker = _props3.singleDatePicker,
          disableFutureDate = _props3.disableFutureDate,
          hideCases = _props3.hideCases,
          minimumNights = _props3.minimumNights;
      var _state6 = this.state,
          focusedInput = _state6.focusedInput,
          specialcase = _state6.specialcase,
          closeSinglePicker = _state6.closeSinglePicker,
          focused = _state6.focused,
          startDateDisplay = _state6.startDateDisplay,
          endDateDisplay = _state6.endDateDisplay,
          singleDateDisplay = _state6.singleDateDisplay;

      var content = [{ ref: "today", key: "today", type: "radio", id: "today", name: "Today", className: "binary_radio", checked: specialcase === 1, value: "1" }, { ref: "7days", key: "7days", type: "radio", id: "7days", name: "7 Days", className: "binary_radio", checked: specialcase === 7, value: "7" }, { ref: "30days", key: "30days", type: "radio", id: "30days", name: "30 Days", className: "binary_radio", checked: specialcase === 30, value: "30" }, { ref: "90days", key: "90days", type: "radio", id: "90days", name: "90 Days", className: "binary_radio", checked: specialcase === 90, value: "90" }, { ref: "365days", key: "365days", type: "radio", id: "365days", name: "1 Year", className: "binary_radio", checked: specialcase === 365, value: "365" }, { ref: "customdays", key: "customdays", type: "radio", id: "customdays", name: "Custom", className: "binary_radio", checked: specialcase === null, value: "custom" }];
      var currContent = hideCases ? this.handleHideCases(content, hideCases) : content;

      return _react2.default.createElement(
        DateRangeContainer,
        { 'data-qa': testId, closeSinglePicker: closeSinglePicker, 'data-theme': themeId },
        _react2.default.createElement(
          DateRangeNote,
          null,
          'All dates and times in ',
          this.props.timezone
        ),
        !noprefix && _react2.default.createElement(_MozartRadio2.default, { horizontal: horizontal, onChange: this.handleRadioBoxClick.bind(this), content: currContent }),
        !singleDatePicker && _react2.default.createElement(_reactDates.DateRangePicker, {
          id: id,
          key: 'DateRangePicker',
          onDatesChange: this.onDatesChange.bind(this),
          onFocusChange: this.onFocusChange.bind(this),
          focusedInput: focusedInput,
          startDate: startDateDisplay,
          startDateId: 'startMyDatePicker',
          endDate: endDateDisplay,
          endDateId: 'endMyDatePicker',
          onClose: this.onClose.bind(this),
          minimumNights: minimumNights,
          isOutsideRange: disableFutureDate ? function (day) {
            return (0, _moment2.default)().diff(day) < 0;
          } : function () {}
        }),
        singleDatePicker && _react2.default.createElement(_reactDates.SingleDatePicker, {
          id: id,
          autoFocus: false,
          key: 'SingleDatePicker',
          date: singleDateDisplay,
          focused: focused,
          onDateChange: this.onDateChangeSingle.bind(this),
          onFocusChange: this.onFocusChange.bind(this),
          numberOfMonths: 1,
          isOutsideRange: disableFutureDate ? function (day) {
            return (0, _moment2.default)().diff(day) < 0;
          } : function () {},
          onClose: this.onCloseSingle.bind(this)
        }),
        this.getSevenDaysRestrictMsg()
      );
    }
  }]);

  return MozartDatePicker;
}(_react.Component);

MozartDatePicker.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** type specifies cancel or submit the field */
  type: _propTypes2.default.string,
  /** previously select start and end date*/
  prevFilterDataStart: _propTypes2.default.object,
  prevFilterDataEnd: _propTypes2.default.object,
  /** initial single date value*/
  singleDateDisplay: _propTypes2.default.object,
  /** if true no radio box prefix Today 7 days 30 days ... */
  noprefix: _propTypes2.default.bool,
  /** when set the default radio box will be checked */
  specialcase: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  /** when changed this will get called 3 times with name and value as params for the callback. Names are start_date, end_date and specialcase(30, 90, 365, null) null means custom */
  handleChange: _propTypes2.default.func.isRequired,
  /** timezone label */
  timezone: _propTypes2.default.string,
  /** id */
  id: _propTypes2.default.string.isRequired,
  /** save dates when select dates if saveCookieWithoutButton assigned true */
  saveCookieWithoutButton: _propTypes2.default.bool,
  /** list all radio button horizontally if horizontal passed */
  horizontal: _propTypes2.default.bool,
  /** create a single date picker if its value is true */
  singleDatePicker: _propTypes2.default.bool,
  autoFocus: _propTypes2.default.bool,
  autoFocusEndDate: _propTypes2.default.bool,
  disableFutureDate: _propTypes2.default.bool,
  /** list special case need to hide */
  hideCases: _propTypes2.default.array,
  /** restrict custom date range to be 7 days */
  sevenDaysRestrict: _propTypes2.default.bool,
  /** restrict minimal custom date range */
  minimumNights: _propTypes2.default.number,
  /** cookie life time */
  cookieLifeTime: _propTypes2.default.number
};
MozartDatePicker.defaultProps = {
  cancel: '',
  timezone: 'UTC',
  noprefix: false,
  autoFocusEndDate: false,
  hoizontal: false,
  disableFutureDate: true,
  sevenDaysRestrict: false,
  testId: 'MozartDatePicker',
  themeId: 'MozartDatePicker',
  minimumNights: 0,
  cookieLifeTime: 30,
  type: 'submit'
};
exports.default = MozartDatePicker;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartDatePicker/MozartDatePicker.js
// module id = 2084
// module chunks = 1